'use strict';

var shippingAddressUpdate = require('newbalance/checkout/shippingAddressUpdate');
var clientSideValidation = require('../components/clientSideValidation');
var $shipping = $('.shipping-content');
var $pickupButton = $('.js-yamato-pickup');
var $siteMap = $('#yamato-site-map');
var $invalid = $('.js-yamato-cta .invalid-feedback');
var invalidClass = 'is-invalid';

/**
 * Convert full-width space (U+3000) to half-width space
 * @param {string} str String to convert
 * @returns {string} String with full-width characters converted to half-width
 */
function fullWidthToHalfWidth(str) {
    return str.replace(/[\uFF01-\uFF5E]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xFEE0);
    }).replace(/\u3000/g, ' ');
}

/**
 * Fill in the store data in the UI
 * @param {Object} storeData - store information
 */
var fillStoreInfo = function (storeData) {
    $('.yamato-store-info').removeClass('d-none');
    $('.yamato-store-name').text(storeData.NM);
    $('.yamato-store-address').text(storeData.ZIP + storeData.ADR);
    $('.yamato-store-phone').text(storeData.TEL);
};

/**
 * Changes the map selection button
 * @param {string} type select/change
 */
var setButton = function (type) {
    var primary = 'button-primary';
    if (type === 'select' && !$pickupButton.hasClass(primary)) {
        $pickupButton.addClass(primary);
        $pickupButton.removeClass('button-secondary button-small');
        $pickupButton.find('.select-store').removeClass('d-none');
        $pickupButton.find('.change-store').addClass('d-none');
    } else if (type === 'change' && !$pickupButton.hasClass('button-secondary')) {
        $pickupButton.addClass('button-secondary button-small');
        $pickupButton.removeClass(primary);
        $pickupButton.find('.select-store').addClass('d-none');
        $pickupButton.find('.change-store').removeClass('d-none');
    }
};

/**
 * Add the store data to the shipping form
 * @param {Object} pickupData - store information
 */
var selectPickupLocation = function (pickupData) {
    var url = $('#yamato-iframe-wrapper').attr('data-parseaddress') + '?address=' + pickupData.ADR;

    // Store both gift wrap checkbox and gift wrap selected dropdown values
    var isGiftWrapChecked = $('input[name$=_isGiftWrap]').prop('checked');
    var giftWrapTextValue = $('#giftWrapText').val();

    $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
            if (!data.error) {
                if (data.address1) {
                    // Convert full-width characters in address to half-width to pass shipping validation
                    $shipping.find('.shippingAddressOne').val(fullWidthToHalfWidth(data.address1));
                }

                if (data.city) {
                    $shipping.find('.shippingAddressCity').val(data.city).trigger('change');
                }

                if (data.prefecture) {
                    $shipping.find('#shippingState').val(data.prefecture).trigger('change');
                }

                if (pickupData.ZIP) {
                    $shipping.find('.shippingZipCode').val(pickupData.ZIP).trigger('change');
                }

                // Store ID
                $('.yamato-pickup').val(pickupData.DCD);

                var $shippingForm = $('.shipping-form');
                var shippingHelpers = require('./shipping');

                // Add event handler before updating shipping method
                $('body').on('checkout:updateCheckoutView', function () {
                    // Restore gift wrap state after store selected and update view for accessibility threshold
                    var $giftWrapMessage = $('.gift-wrap-message');

                    $('input[name$=_isGiftWrap]').prop('checked', isGiftWrapChecked).attr('aria-expanded', isGiftWrapChecked).trigger('change');

                    if (isGiftWrapChecked) {
                        $('#giftWrapText').val(giftWrapTextValue);
                        $giftWrapMessage.removeClass('d-none').attr('aria-hidden', 'false');
                    } else {
                        $giftWrapMessage.attr('aria-hidden', 'true');
                    }
                });

                shippingHelpers.methods.updateShippingMethodList($shippingForm);

                fillStoreInfo(pickupData);
                setButton('change');
                $('.submit-shipping').removeClass('d-none');
                $siteMap.modal('hide');
            } else {
                $siteMap.modal('hide');
                $invalid.show();
                $pickupButton.addClass(invalidClass);
                window.console.log(data.message);
            }
        },
        error: function (err) {
            $siteMap.modal('hide');
            $invalid.show();
            $pickupButton.addClass(invalidClass);
            window.console.log(err);
        }
    });
};

/**
 * Show or hides the shipping methods based on selection
 */
var displayShippingMethod = function () {
    var $shippingTypeRegular = $('.shipping-type-regular');
    var $shippingTypeYamato = $('.shipping-type-yamato');
    $shippingTypeRegular.find('input[data-shippingtype="yamato"]').parent().remove();
    $shippingTypeYamato.find('input[data-shippingtype="regular"]').parent().remove();
    $shippingTypeYamato.find('input[data-shippingtype="access-point"]').parent().remove();
};

/**
 * Search for pickup location
 * @param {string} zip Zip code
 */
function search(zip) {
    $('#yamato-search-results').empty();
    $siteMap.modal('show').find('.modal-body').spinner()
        .start();
    var $searchForm = $('#yamato-search-form');
    var searchUrl = $('#yamato-search-submit').attr('data-search');
    $.ajax({
        url: searchUrl + '?zip=' + zip,
        method: 'GET',
        success: function (data) {
            if (data.error) {
                var $searchInput = $('#yamatoStoreSearch');
                var errorMsg = $searchInput.attr('data-' + data.errorType);
                $searchForm.find('.invalid-feedback').text(errorMsg);
                $searchInput.addClass(invalidClass);
            } else {
                $('#yamato-search-results').html(data);
            }
            $.spinner().stop();
        },
        error: function (err) {
            window.console.log(err);
            $.spinner().stop();
        }
    });
}

/**
 * Add button listener
 */
var addEventListeners = function () {
    var eventOrigin = window.sitePrefs.yamatoMessageEventOrigin;

    $('#yamato-modal').on('click', function (e) {
        e.preventDefault();
        $('.js-yamato-cta').find('.invalid-feedback').hide();
        $siteMap.modal('show');
    });

    // Get store info from site map selection
    window.addEventListener('message', (event) => {
        if (event.origin === eventOrigin) {
            selectPickupLocation(event.data);
        }
    }, false);

    // Search by postal code
    $('#yamato-search-submit').on('click', function (e) {
        e.preventDefault();
        var validForm = clientSideValidation.functions.validatePartialForm($('#yamato-search-form'), e);
        var zip = $('#yamatoStoreSearch').val();
        if (validForm) {
            search(zip);
        }
    });

    // User selects store from search results
    $('.yamato-store-finder').on('click', '.store-details-select', function (e) {
        e.preventDefault();
        var storeData = $(this).attr('data-filtered');
        selectPickupLocation(JSON.parse(storeData));
    });
};

module.exports = {
    methods: {
        displayShippingMethod: displayShippingMethod
    },
    initYamato: function () {
        shippingAddressUpdate.isShippingRegular();
        shippingAddressUpdate.addEventListeners();
        addEventListeners();

        $shipping.on('click', '#shipping-type-selector-yamato', function (e) {
            e.stopImmediatePropagation();
            $invalid.hide();
            $pickupButton.removeClass(invalidClass);
            setButton('select');
            shippingAddressUpdate.clearForm();
            shippingAddressUpdate.selectShippingType('yamato');
        });
    }
};
